import { PageType } from "shared/lib/page-type";

import type { GameType } from "scmp-app/components/games/types";

export const pathname = "/games/crossword";

export const page = {
  route(query: QueryParameters<{ gameType?: GameType }>) {
    return { pathname, query: { ...query, pageType: PageType.GamesCrosswords } };
  },
};
